import axios from 'axios'
import { MODULES_BASE_URLS } from 'src/common/constants'

export default class UserValidationService {
    static instance

    static getInstance() {
        if (!UserValidationService.instance) {
            UserValidationService.instance = new UserValidationService()
        }
        return UserValidationService.instance
    }

    async checkEmailExistence(payload, module = 'wb') {
        // we should change base url based on selected module later. this is a backend bug
        const response = await axios.post(`${MODULES_BASE_URLS['tp']}/user/check_existence`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );
    
        return response.data.data
    }

}
